import EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';
import LocationCommonWellItemViewState from 'owa-location-common-well/lib/store/schema/LocationCommonWellItemViewState';
import { action } from 'satcheljs';

/**
 * handle room added and updates Locations and resources in the calendar event
 */
export let onRoomAdded = action('onRoomAdded', (name: string, emailAddress: string) => ({
    name,
    emailAddress,
}));

export let addLocationsFromCommonWell = action(
    'addLocationsFromCommonWell',
    (newLocations: LocationCommonWellItemViewState[]) => ({
        newLocations,
    })
);

export let removeLocationsFromCommonWell = action(
    'removeLocationsFromCommonWell',
    (removedLocations: LocationCommonWellItemViewState[]) => ({
        removedLocations,
    })
);

/**
 * Action called when loctions collection needs to be updated.
 * This will update locations and the resources collection on the calendar event
 */
export let updateLocations = action('updateLocations', (locations: EnhancedLocation[]) => ({
    locations,
}));

/**
 * Action called when locations resolved and it calls mutator to set it into compose store
 */
export let onLocationsChanged = action('onLocationsChanged', (locations: EnhancedLocation[]) => ({
    locations,
}));
